







































































































import Vue, { VueConstructor } from "vue";
import VaButton from "@/components/atoms/VaButton.vue";
import validationMixin from "@/components/mixins/validationMixin";
import VaTextField from "@/components/atoms/VaTextField.vue";
import VaSwitch from "@/components/atoms/VaSwitch.vue";
import FileUploader from "@/components/shared/FileUploader.vue";
import wizardStepsMixin, {
  WizardMixin,
} from "@/components/mixins/wizardStepsMixin";
import {
  fileFormatted2WizardConfigurationFile,
  WizardConfiguration,
  WizardConfigurationFile,
} from "@/models/wizardConfiguration";
import cloneDeep from "lodash/clone";
import { FileFormatted } from "@/models/file";

export default (Vue as VueConstructor<WizardMixin>).extend({
  name: "StepAppearance",
  mixins: [wizardStepsMixin, validationMixin],
  data() {
    return {
      config: {
        roomName: this.deviceConfiguration.deviceDescription || "",
        showCustomLogo: false,
        customLogo: {} as WizardConfigurationFile,
        showCustomBackgrounds: false,
        customBackgrounds: [] as WizardConfigurationFile[],
        customWifi: false,
        customSSID: "",
        customPass: "",
        screenSharingPin: false,
        rebootTime: "11:59 PM",
      },
      loading: false,
    };
  },
  components: { FileUploader, VaSwitch, VaTextField, VaButton },
  watch: {
    deviceConfiguration: function (newVal) {
      this.config.roomName = newVal.deviceDescription;
    },
  },
  methods: {
    onFinish() {
      const res = this.wizardConfiguration
        ? cloneDeep(this.wizardConfiguration)
        : ({} as WizardConfiguration);
      res.roomName = this.config.roomName;
      res.showCustomLogo = this.config.showCustomLogo;
      res.customLogo = res.showCustomLogo ? this.config.customLogo : undefined;
      res.showCustomBackgrounds = this.config.showCustomBackgrounds;
      res.customBackgrounds = res.showCustomBackgrounds
        ? this.config.customBackgrounds
        : [];
      res.wifiSSID = this.config.customSSID;
      res.wifiPassword = this.config.customPass;
      res.screenSharingPin = this.config.screenSharingPin;
      res.rebootTime = this.config.rebootTime;
      this.$emit("onUpdateConfig", res);
      this.onNext();
    },

    /* eslint-disable  @typescript-eslint/no-explicit-any */
    async onUploadLogo(logo: FileFormatted): Promise<void> {
      this.config.customLogo = fileFormatted2WizardConfigurationFile(logo);
    },
    /* eslint-disable  @typescript-eslint/no-explicit-any */
    async onUploadBg(backgrounds: Array<FileFormatted>): Promise<void> {
      this.config.customBackgrounds = backgrounds.map(
        fileFormatted2WizardConfigurationFile
      );
    },
  },
});
